import React, { useState, createContext, lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from "./Components/Home";
import ProtectedRoute from "./Components/Admin/ProtectedRoute";

// Lazy Loading for performance
const Data = lazy(() => import("./Components/Data"));
const Login = lazy(() => import("./Components/Admin/Login"));
const Dashboard = lazy(() => import("./Components/Admin/Dashboard"));

export const UserContext = createContext();

function App() {
  const [state, setState] = useState(0);
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  // Loading fallback
  const Loading = () => (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );

  return (
    <UserContext.Provider value={{ state, setState, theme, toggleTheme }}>
      <div className={`App ${theme}`}>
        <Toaster position="top-right" />
        <Router>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project/:id" element={<Data />} />
              <Route path="/admin/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/admin/dashboard" element={<Dashboard />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      </div>
    </UserContext.Provider>
  );
}

export default App;
